var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "div",
      { staticClass: "loading style-2" },
      [
        _c("v-progress-circular", {
          staticClass: "loading-wheel",
          attrs: { color: "primary", size: "100", indeterminate: "" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }